import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash.isempty';
import { DatePicker } from 'antd';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import moment from 'moment'
import {
  Grid, Button,
} from '@material-ui/core';
import { GetCustomerOverview, GetYearOverview, GetYearConsultantOverview, GetYearStudentOverview, GetYearThemeOverview, GetYearLeadsOverview } from './overviewReportsAction';
import OverLoader from '../../components/common/loader';
import { Document, Page } from "react-pdf/dist/entry.webpack";
import { LogoutAction } from '../../actions';

const dateFormat = 'YYYY';

class OverviewPDF extends Component {

  state = {
    yearField: new Date().getFullYear(),
    numPages: null,
    pageNumber: 1,
    scale: 1.0,
    customerOverviewPdf: ''
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  };
  onPageLoad = (page) => {
    const parentDiv = document.querySelector('#pdfDocument')
    let pageScale = parentDiv.clientWidth / page.originalWidth
    if (this.state.scale !== pageScale) {
      this.setState({ scale: pageScale });
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { customer_overview_pdf } = this.props
    if (nextProps.customer_overview_pdf !== customer_overview_pdf) {
      this.setState({ customerOverviewPdf: nextProps.customer_overview_pdf })
    }
  }

  componentDidMount = () => {
    const { GetCustomerOverview, GetYearOverview, GetYearConsultantOverview, GetYearStudentOverview, GetYearThemeOverview, GetYearLeadsOverview, pdf } = this.props
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const { yearField } = this.state
    const token = localStorage.getItem('access-token')
    if (token !== null) {
      if (pdf === "Jahresübersicht_Kunden_" && Number(access_rights.year_overview_customers) !== 0)
        GetCustomerOverview(yearField)
      else if (pdf === "Jahresübersicht_Projekte_" && Number(access_rights.year_overview_projects) !== 0)
        GetYearOverview(yearField)
      else if (pdf === "Jahresübersicht_Berater_" && Number(access_rights.year_overview_consultants) !== 0)
        GetYearConsultantOverview(yearField)
      else if (pdf === "Jahresübersicht_Studenten_" && Number(access_rights.year_overview_students) !== 0)
        GetYearStudentOverview(yearField)
      else if (pdf === "Jahresübersicht_Themen_" && Number(access_rights.year_overview_themes) !== 0)
        GetYearThemeOverview(yearField)
      else if (pdf === "Jahresübersicht_Leads_" && Number(access_rights.year_overview_leads) !== 0)
        GetYearLeadsOverview(yearField)
    }
  }

  yearFieldHandleChange = (e) => {
    if (e !== null) {
      let date = moment(e._d).format("YYYY");
      this.setState({ yearField: date, consultant_pdf: '' }, () => this.getConsultantPlans())
    } else {
      this.setState({ yearField: '' })
    }
  }


  getConsultantPlans = () => {
    const { GetCustomerOverview, GetYearOverview, GetYearConsultantOverview, GetYearStudentOverview, GetYearThemeOverview, GetYearLeadsOverview, pdf } = this.props
    const { yearField } = this.state
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')
    if (token !== null) {
      if (pdf === "Jahresübersicht_Kunden_" && Number(access_rights.year_overview_customers) !== 0)
        GetCustomerOverview(yearField)
      else if (pdf === "Jahresübersicht_Projekte_" && Number(access_rights.year_overview_projects) !== 0)
        GetYearOverview(yearField)
      else if (pdf === "Jahresübersicht_Berater_" && Number(access_rights.year_overview_consultants) !== 0)
        GetYearConsultantOverview(yearField)
      else if (pdf === "Jahresübersicht_Studenten_" && Number(access_rights.year_overview_students) !== 0)
        GetYearStudentOverview(yearField)
      else if (pdf === "Jahresübersicht_Themen_" && Number(access_rights.year_overview_themes) !== 0)
        GetYearThemeOverview(yearField)
      else if (pdf === "Jahresübersicht_Leads_" && Number(access_rights.year_overview_leads) !== 0)
        GetYearLeadsOverview(yearField)
    }
  }

  render() {
    const { yearField, pageNumber, scale, customerOverviewPdf, numPages } = this.state
    const { isloading, pdf } = this.props
    const token = localStorage.getItem('access-token')
    if (token === null) {
      this.props.LogoutAction()
    }
    return (
      <div className="plainingTab plainingTab-action">
        {isloading && <OverLoader />}
        {customerOverviewPdf || isloading ?
          <Fragment>
            <Grid container spacing={2}>
              <Grid item xs={2} className="inner-p-label">
                <div className="innermeLable">Jahr</div>
                <DatePicker
                  value={yearField === "" ? '' : moment(yearField, dateFormat)}
                  format={dateFormat}
                  allowClear={false}
                  bordered={false}
                  onChange={(e) => {
                    this.yearFieldHandleChange(e)
                  }}
                  picker="year" />
              </Grid>
              {!isEmpty(customerOverviewPdf) &&
                <Grid item xs={4} className="inner-p-label">
                  {/* <a href={customerOverviewPdf} target="_blank"> */}
                  <Button variant="outlined" color="primary"
                    onClick={() => {
                      const theLink = document.createElement('a');
                      theLink.href = customerOverviewPdf;
                      theLink.download = pdf + yearField + ".pdf";
                      document.body.appendChild(theLink);
                      theLink.click();
                      document.body.removeChild(theLink);
                    }
                    }
                  >Drucken</Button>
                  {/* </a> */}
                </Grid>
              }
            </Grid>

            {!isEmpty(customerOverviewPdf) &&
              <div id="pdfDocument">
                <ZoomInIcon onClick={() => { if (scale <= 3) this.setState({ scale: scale + 0.25 }) }}
                >Zoom in</ZoomInIcon>
                <ZoomOutIcon onClick={() => { if (scale >= 1) this.setState({ scale: scale - 0.25 }) }}
                >Zoom out</ZoomOutIcon>
                <div className="pagination">
                  <NavigateBeforeIcon onClick={() => { if (pageNumber > 1) this.setState({ pageNumber: pageNumber - 1 }) }} />
                  <span>{pageNumber}</span>
                  <span>/{numPages}</span>
                  <NavigateNextIcon onClick={() => { if (pageNumber < numPages) this.setState({ pageNumber: pageNumber + 1 }) }} />
                </div>
                <Document
                  file={customerOverviewPdf}
                  onLoadSuccess={this.onDocumentLoadSuccess}
                >
                  <Page
                    onLoadSuccess={this.onPageLoad}
                    pageNumber={pageNumber}
                    scale={scale} />
                </Document>
              </div>
            }
          </Fragment>
          :
          <Grid item md={12} sm={12} xs={12}>
            <div className="rightBlock rightBlock-bgWhite user-system">
              <h3>Internal Server Error</h3>
            </div>
          </Grid>
        }
      </div>
    )
  }
}

const mapStateToProps = ({ customerOverview }) => {
  return {
    customer_overview_pdf: customerOverview.customer_overview,
    isloading: customerOverview.loading,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    GetCustomerOverview: (year) => dispatch(GetCustomerOverview(year)),
    GetYearOverview: (year) => dispatch(GetYearOverview(year)),
    GetYearConsultantOverview: (year) => dispatch(GetYearConsultantOverview(year)),
    GetYearStudentOverview: (year) => dispatch(GetYearStudentOverview(year)),
    GetYearThemeOverview: (year) => dispatch(GetYearThemeOverview(year)),
    GetYearLeadsOverview: (year) => dispatch(GetYearLeadsOverview(year)),
    LogoutAction: () => dispatch(LogoutAction()),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(OverviewPDF)